import { render, staticRenderFns } from "./Report002.vue?vue&type=template&id=28012dee&scoped=true"
import script from "./Report002.vue?vue&type=script&lang=js"
export * from "./Report002.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28012dee",
  null
  
)

export default component.exports